import { Pokemon } from "../models/Pokemon";

//abilities
export const medQOne = [
  "overgrow",
  "blaze",
  "torrent",
  "shed skin",
  "keen eye",
  "run away",
  "intimidate",
  "static",
  "sand veil",
  "poison point",
  "cute charm",
  "flash fire",
  "inner focus",
  "chlorophyll",
  "effect spore",
  "shield dust",
  "limber",
  "damp",
  "vital spirit",
  "water absorb",
  "synchronize",
  "guts",
  "clear body",
  "run away",
  "oblivious",
  "magnet pull",
  "thick fat",
  "stench",
  "shell armor",
  "levitate",
  "insomnia",
  "hyper cutter",
  "soundproof",
  "rock head",
  "lightning rod",
  "swift swim",
  "illuminate",
];

//evolves from
export const medQTwo = [
  "nidoran-m",
  "bulbasaur",
  "charmander",
  "squirtle",
  "caterpie",
  "weedle",
  "pidgey",
  "rattata",
  "spearow",
  "ekans",
  "pikachu",
  "sandshrew",
  "nidoran-f",
  "clefiary",
  "vulpix",
  "jigglypuff",
  "zubat",
  "oddish",
  "paras",
  "venonat",
  "diglett",
  "meowth",
  "psyduck",
  "mankey",
  "growlithe",
  "poliwag",
  "abra",
  "machop",
  "bellsprout",
  "tentacool",
  "geodude",
  "ponyta",
  "slowpoke",
  "magnemite",
  "doduo",
  "seel",
  "grimer",
  "shellder",
  "gastly",
  "drowzee",
  "krabby",
  "voltorb",
  "exeggcute",
  "cubone",
  "koffing",
  "rythorn",
  "horsea",
  "goldeen",
  "staryu",
  "magikarp",
  "omanyte",
  "kabuto",
  "dratini",
];

//evolves to
export const medQThree = [
  "venusaur",
  "charizard",
  "blastoise",
  "butterfree",
  "beedrill",
  "pidgeot",
  "nidoqueen",
  "nidoking",
  "vileplume",
  "poliwrath",
  "alakazam",
  "machamp",
  "victreebel",
  "golem",
  "gengar",
  "hitmonlee",
  "hitmonchan",
  "lapras",
  "eevee",
  "vaporeon",
  "jolteon",
  "flareon",
  "aerodactyl",
  "snorlax",
  "articuno",
  "zapdos",
  "moltres",
  "dragonite",
  "mewtwo",
  "mew",
  "no evolution",
];

export const medPokemon: Pokemon[] = [
  {
    id: 2,
    name: "ivysaur",
    abilities: "overgrow",
    evolvesFrom: "bulbasaur",
    evolvesTo: "venusaur",
  },
  {
    id: 5,
    name: "charmeleon",
    abilities: "blaze",
    evolvesFrom: "charmander",
    evolvesTo: "charizard",
  },
  {
    id: 8,
    name: "wartortle",
    abilities: "torrent",
    evolvesFrom: "squirtle",
    evolvesTo: "blastoise",
  },
  {
    id: 11,
    name: "metapod",
    abilities: "shed skin",
    evolvesFrom: "caterpie",
    evolvesTo: "butterfree",
  },
  {
    id: 14,
    name: "Kakuna",
    abilities: " shed skin",
    evolvesFrom: "weedle",
    evolvesTo: "beedrill",
  },
  {
    id: 17,
    name: "pidgeotto",
    abilities: "keen eye",
    evolvesFrom: "pidgey",
    evolvesTo: "pidgeot",
  },
  {
    id: 20,
    name: "raticate",
    abilities: "run away",
    evolvesFrom: "rattata",
    evolvesTo: "no evolution",
  },
  {
    id: 22,
    name: "fearow",
    abilities: "keen eye",
    evolvesFrom: "spearow",
    evolvesTo: "no evolution",
  },
  {
    id: 24,
    name: "arbok",
    abilities: "intimidate",
    evolvesFrom: "ekans",
    evolvesTo: "no evolution",
  },
  {
    id: 26,
    name: "raichu",
    abilities: "static",
    evolvesFrom: "pikachu",
    evolvesTo: "no evolution",
  },
  {
    id: 28,
    name: "sandslash",
    abilities: "sand veil",
    evolvesFrom: "sandshrew",
    evolvesTo: "no evolution",
  },
  {
    id: 30,
    name: "nidorina",
    abilities: "poison point",
    evolvesFrom: "nidoran-f",
    evolvesTo: "nidoqueen",
  },
  {
    id: 33,
    name: "nidorino",
    abilities: "poison point",
    evolvesFrom: "nidoran-m",
    evolvesTo: "nidoking",
  },
  {
    id: 36,
    name: "clefable",
    abilities: "cute charm",
    evolvesFrom: "clefairy",
    evolvesTo: "no evolution",
  },
  {
    id: 38,
    name: "ninetales",
    abilities: "flash fire",
    evolvesFrom: "vulpix",
    evolvesTo: "no evolution",
  },
  {
    id: 40,
    name: "wigglytuff",
    abilities: "cute charm",
    evolvesFrom: "jigglypuff",
    evolvesTo: "no evolution",
  },
  {
    id: 42,
    name: "golbat",
    abilities: "inner focus",
    evolvesFrom: "zubat",
    evolvesTo: "no evolution",
  },
  {
    id: 44,
    name: "gloom",
    abilities: "chlorophyll",
    evolvesFrom: "oddish",
    evolvesTo: "vileplume",
  },
  {
    id: 47,
    name: "parasect",
    abilities: "effect spore",
    evolvesFrom: "paras",
    evolvesTo: "no evolution",
  },
  {
    id: 49,
    name: "venomoth",
    abilities: "shield dust",
    evolvesFrom: "venonant",
    evolvesTo: "no evolution",
  },
  {
    id: 51,
    name: "dugtrio",
    abilities: "sand veil",
    evolvesFrom: "diglett",
    evolvesTo: "no evolution",
  },
  {
    id: 53,
    name: "persian",
    abilities: "limber",
    evolvesFrom: "meowth",
    evolvesTo: "no evolution",
  },
  {
    id: 55,
    name: "golduck",
    abilities: "damp",
    evolvesFrom: "psyduck",
    evolvesTo: "no evolution",
  },
  {
    id: 57,
    name: "primeape",
    abilities: "vital spirit",
    evolvesFrom: "mankey",
    evolvesTo: "no evolution",
  },
  {
    id: 59,
    name: "arcanine",
    abilities: "intimidate",
    evolvesFrom: "growlithe",
    evolvesTo: "no evolution",
  },
  {
    id: 61,
    name: "poliwhirl",
    abilities: "water absorb",
    evolvesFrom: "poliwag",
    evolvesTo: "poliwrath",
  },
  {
    id: 64,
    name: "kadabra",
    abilities: "synchronize",
    evolvesFrom: "abra",
    evolvesTo: "alakazam",
  },
  {
    id: 67,
    name: "machoke",
    abilities: "guts",
    evolvesFrom: "machop",
    evolvesTo: "machamp",
  },
  {
    id: 70,
    name: "weepinbell",
    abilities: "chlorophyll",
    evolvesFrom: "bellsprout",
    evolvesTo: "victreebel",
  },
  {
    id: 73,
    name: "tentacruel",
    abilities: "clear body",
    evolvesFrom: "tentacool",
    evolvesTo: "no evolution",
  },
  {
    id: 75,
    name: "graveler",
    abilities: " rock head",
    evolvesFrom: "geodude",
    evolvesTo: "golem",
  },
  {
    id: 78,
    name: "rapidash",
    abilities: "run away",
    evolvesFrom: "ponyta",
    evolvesTo: "no evolution",
  },
  {
    id: 80,
    name: "slowbro",
    abilities: "oblivious",
    evolvesFrom: "slowpoke",
    evolvesTo: "no evolution",
  },
  {
    id: 82,
    name: "magneton",
    abilities: "magnet pull",
    evolvesFrom: "magnemite",
    evolvesTo: "no evolution",
  },
  {
    id: 85,
    name: "dodrio",
    abilities: "run away",
    evolvesFrom: "doduo",
    evolvesTo: "no evolution",
  },
  {
    id: 87,
    name: "dewgong",
    abilities: "thick fat",
    evolvesFrom: "seel",
    evolvesTo: "no evolution",
  },
  {
    id: 89,
    name: "muk",
    abilities: "stench",
    evolvesFrom: "grimer",
    evolvesTo: "no evolution",
  },
  {
    id: 91,
    name: "cloyster",
    abilities: "shell armor",
    evolvesFrom: "shellder",
    evolvesTo: "no evolution",
  },
  {
    id: 93,
    name: "haunter",
    abilities: "levitate",
    evolvesFrom: "gastly",
    evolvesTo: "gengar",
  },
  {
    id: 97,
    name: "hypno",
    abilities: "insomnia",
    evolvesFrom: "drowzee",
    evolvesTo: "no evolution",
  },
  {
    id: 99,
    name: "kingler",
    abilities: "hyper cutter",
    evolvesFrom: "krabby",
    evolvesTo: "no evolution",
  },
  {
    id: 101,
    name: "electrode",
    abilities: "soundproof",
    evolvesFrom: "voltorb",
    evolvesTo: "no evolution",
  },
  {
    id: 103,
    name: "exeggutor",
    abilities: "chlorophyll",
    evolvesFrom: "exeggcute",
    evolvesTo: "no evolution",
  },
  {
    id: 105,
    name: "marowak",
    abilities: "rock hard",
    evolvesFrom: "cubone",
    evolvesTo: "no evolution",
  },
  {
    id: 110,
    name: "weezing",
    abilities: "levitate",
    evolvesFrom: "koffing",
    evolvesTo: "no evolution",
  },
  {
    id: 112,
    name: "rhydon",
    abilities: "lightning rod",
    evolvesFrom: "rhyhorn",
    evolvesTo: "no evolution",
  },
  {
    id: 117,
    name: "seadra",
    abilities: "poison point",
    evolvesFrom: "horsea",
    evolvesTo: "no evolution",
  },
  {
    id: 119,
    name: "seaking",
    abilities: "swift swim",
    evolvesFrom: "goldeen",
    evolvesTo: "no evolution",
  },
  {
    id: 121,
    name: "starmie",
    abilities: "natural cure",
    evolvesFrom: "staryu",
    evolvesTo: "no evolution",
  },
  {
    id: 130,
    name: "gyarados",
    abilities: "intimidate",
    evolvesFrom: "magikarp",
    evolvesTo: "no evolution",
  },
  {
    id: 139,
    name: "omastar",
    abilities: "swift swim",
    evolvesFrom: "omanyte",
    evolvesTo: "no evolution",
  },
  {
    id: 141,
    name: "kabutops",
    abilities: "swift swim",
    evolvesFrom: "kabuto",
    evolvesTo: "no evolution",
  },
  {
    id: 148,
    name: "dragonair",
    abilities: "shed skin",
    evolvesFrom: "dratini",
    evolvesTo: "dragonite",
  },
];
